/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
export class FormBase<T> {
    value: T;
    key: string;
    label: string;
    order: number;
    controlType: string;
    validators: {};
    columnWidth: number;
    /**
     * if true make the field as readonly/non-editable
     */
    readonly: boolean;
    /**
     * display the field if condition === true || condition === undefined; 
     * otherwise if condition === false don't display the field in the form.
     */
    condition: boolean;

    constructor(option: {
        value?: T,
        key?: string,
        label?: string,
        order?: number,
        controlType?: string,
        validators?: T,
        columnWidth?: number,
        readonly?: boolean,
        condition?: boolean
    } = {}) {
        this.value = option.value;
        this.key = option.key || '';
        this.label = option.label || '';
        this.order = option.order === undefined ? 1 : option.order;
        this.controlType = option.controlType || '';
        this.validators = option.validators;
        this.columnWidth = option.columnWidth;
        this.readonly = option.readonly;
        this.condition = option.condition;
    }
}

